import { render, staticRenderFns } from "./study-participant-edcForm.vue?vue&type=template&id=617a8647&scoped=true&"
import script from "./study-participant-edcForm.vue?vue&type=script&lang=js&"
export * from "./study-participant-edcForm.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-edcForm.vue?vue&type=style&index=0&id=617a8647&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a8647",
  null
  
)

component.options.__file = "study-participant-edcForm.vue"
export default component.exports